import React, { Component } from 'react';


class CancellationRefundComponent extends Component{
  
    render() 
    { 
      
        return ( 
           < React.Fragment> 
            <div style={{ fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", padding: '1em' }}>
            <h2>Cancellation and Refund Policy</h2>
<p>Thank you for choosing Linux Mantra.</p>
<p>Currently, we do not offer cancellations or refunds for any of our products or services once the transaction is completed. Please review your order carefully before finalizing your purchase.</p>
<p>If you believe you have a special case, please contact our support team at <a href="mailto:support@linuxmantra.com">support@linuxmantra.com</a>.</p>
    </div>

            


            
           </React.Fragment>
        )

}
}

export default CancellationRefundComponent;